import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stringToDate' })
export class StringToDate implements PipeTransform {

    transform(value: string): Date {
        return new Date(value);
    }

}



// WEBPACK FOOTER //
// ./src/app/common/pipe/date.pipe.ts